<template>
  <div class="particles_box">
    <!-- 收货信息 -->
    <div class="order_box container yu_fc">
      <div class="top_title">
        <h3 class="title">收货信息</h3>
      </div>
      <div class="order_address" v-if="addressShow == 0">
        <template v-for="item in goodsAddress">
          <div class="left" v-if="addressId == item.id">
            <div class="line">
              <i></i>
              <p v-if="item.defaultStatus == 1">默认地址</p>
              <span
                @click="editAddress(item.id,item.name,item.phone,item.postCode,item.addrNameFull,item.detailAddress,item.defaultStatus)"
              >修改</span>
            </div>
            <div class="p_line">
              <p>收&ensp;货&ensp;人：</p>
              <span>{{item.name}}</span>
            </div>
            <div class="p_line">
              <p>联系方式：</p>
              <span>{{item.phone}}</span>
            </div>
            <div class="p_line">
              <p>收货地址：</p>
              <span>{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</span>
            </div>
          </div>
        </template>
        <div class="right">
          <p>
            <span class="address_tab" @click="addressTab">地址切换</span>
          </p>
          <p>
            <span class="address_adds" @click="addressAdd">新建地址</span>
          </p>
        </div>
      </div>
      <!-- 添加收货地址 -->
      <div class="order_address_add" v-if="addressShow == 1">
        <div class="left">
          <div class="label">
            <div class="left">所在地区：</div>
            <div class="right">
              <!-- 省市区列表 -->
              <v-distpicker
                :placeholders="placeholders"
                :province="select.province"
                :city="select.city"
                :area="select.area"
                @selected="onSelected"
              ></v-distpicker>
            </div>
          </div>
          <div class="label">
            <div class="left">详情地址：</div>
            <textarea
              placeholder="请填写您的详细地址、街道、门牌号"
              v-model="addressDetail"
              @focus="addressDetailFocus"
            ></textarea>
            <div class="errmes" v-if="addressDetailShow == 1">
              <i></i>详细地址不能为空
            </div>
          </div>
          <div class="label width yu_fl">
            <div class="left">收货人：</div>
            <input type="text" v-model="addressName" @focus="addressNameFocus" />
            <div class="errmes" v-if="addressNameShow == 1">
              <i></i>收货人不能为空
            </div>
          </div>
          <div class="label width yu_fr">
            <div class="left">手机号码：</div>
            <input type="text" maxlength="11" v-model="addressPhone" @focus="addressPhoneFocus" />
            <div class="errmes" v-if="addressPhoneShow == 1">
              <i></i>
              {{addressPhoneMessage}}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="default" :class="defaults == 1 ? 'active' : ''" @click="onDefault">
            <i></i>设为默认
          </div>
          <div class="btns btns_submit" @click="onSubmitAdd">确定</div>
          <div class="btns btns_close" @click="addressClose">取消</div>
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="order_box container yu_fc">
      <div class="top_title">
        <h3 class="title w400">商品信息</h3>
        <h3 class="title yu_tc w180">单价</h3>
        <h3 class="title yu_tc w180">数量</h3>
        <h3 class="title yu_tc w180">小计</h3>
        <h3 class="title yu_tc w210">实付</h3>
      </div>
      <ul class="goods_list">
        <li v-for="(item,index) in goodsList" :key="index">
          <div class="infor yu_fl w400">
            <img :src="item.productPic" />
            <p>{{item.productName}}</p>
            <span>{{item.productAttr}}</span>
          </div>
          <div class="title yu_fl yu_tc w180">
            <span>￥{{item.price}}</span>
            <del>￥{{item.originalPrice}}</del>
          </div>
          <div class="title yu_fl yu_tc w180">
            <span>￥{{item.quantity}}</span>
          </div>
          <div class="title yu_fl yu_tc w180">
            <span>￥{{item.price * item.quantity | money}}</span>
          </div>
          <div class="title yu_fl yu_tc w210">
            <span>￥{{item.price * item.quantity | money}}</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 支付方式 -->
    <div class="order_box container yu_fc">
      <div class="top_title">
        <h3 class="title w400">支付方式</h3>
      </div>
      <div class="pay_aw">
        <label @click="payTab(0)">
          <i class="pay_radio" :class="payType == 0 ? 'active' : ''"></i>
          <i class="payali"></i>
        </label>
        <label @click="payTab(1)">
          <i class="pay_radio" :class="payType == 1 ? 'active' : ''"></i>
          <i class="paywx"></i>
        </label>
      </div>
    </div>
    <!-- 结算信息 -->
    <div class="goods_order container yu_fc">
      <div class="right">
        <dl class="amount">
          <dt>商品合计：</dt>
          <dd>￥{{totalAmount}}</dd>
        </dl>
        <dl class="amount">
          <dt>运费：</dt>
          <dd>￥0.00</dd>
        </dl>
        <hr />
        <dl class="pay">
          <dt>应付总额：</dt>
          <dd>￥{{payAmount}}</dd>
        </dl>
        <div class="goods_order_btn">
          <a
            href="javascript:void(0)"
            class="btn_pay"
            :class="agrees == 0 ? 'active' : ''"
            @click="onPay"
          >去付款</a>
          <div class="errmepay" v-if="addressShowI == 0">
            <i></i>请填写地址
          </div>
        </div>
        <template v-for="item in goodsAddress">
          <div class="adderss_bottom" v-if="addressId == item.id">
            <span>{{item.phone}}</span>
            <span>{{item.name}}</span>
            <p>{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</p>
          </div>
        </template>
      </div>
    </div>
    <!-- 协议 -->
    <div class="agree container yu_fc">
      <a href>《搜精品平台服务协议》</a>
      <div class="image" :class="agrees == 1 ? 'active' : ''" @click="onAgree">
        <i></i>同意
      </div>
    </div>
    <!-- 切换地址 -->
    <div class="yu_mask" v-if="addressShowTab == 1">
      <div class="address_tabs">
        <h3 class="title">选择地址</h3>
        <div class="over_auto">
          <ul class="list">
            <li
              v-for="(item,index) in goodsAddress"
              :key="index"
              @click="onAddressOrder(item.id)"
              :class="addressIds == item.id ? 'active' : ''"
            >
              <div class="p_label">
                <p>收&ensp;货&ensp;人：</p>
                <span>{{item.name}}</span>
              </div>
              <div class="p_label">
                <p>联系方式：</p>
                <span>{{item.phone}}</span>
              </div>
              <div class="p_label">
                <p>收货地址：</p>
                <span>{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</span>
              </div>
              <div class="defaults" v-if="item.defaultStatus == 1">默认地址</div>
            </li>
          </ul>
        </div>
        <div class="btn_addr">
          <div class="btns btns_submit" @click="onOrderAdd">确定</div>
          <div class="btns btns_close" @click="addressClose">取消</div>
        </div>
      </div>
      <div class="yu_back" @click="addressClose"></div>
    </div>
    <!-- 支付遮罩 -->
    <div class="yu_mask" v-if="overlay == 1">
      <div class="over_lay">
        <h3 class="text_h3">
          请在
          <span>1</span>小时内完成付款，否则订单会被系统取消
        </h3>
        <div class="text_clear">
          <div class="left">
            <p>支付成功请点击</p>
            <a href="javascript:void(0)" @click="onOrder">已完成付款</a>
          </div>
          <div class="right">
            <p>遇到问题请点击</p>
            <a href="javascript:void(0)" @click="payCompo(payType,orderSn)">重新付款</a>
          </div>
        </div>
        <p class="text_p">注：重新付款前，请关闭之前的付款页面</p>
      </div>
      <div class="yu_back"></div>
    </div>
  </div>
</template>

<script>
let orderSn = "";
import VDistpicker from "v-distpicker";
import { addrList, addrAdd, addrUpdate } from "@/api/address";
import { cartList } from "@/api/cart";
import {
  orderConfirmCart,
  orderSubmitCart,
  orderConfirmBuy,
  orderSubmitBuy
} from "@/api/order";
import { webWechatPay, webAlipay } from "@/api/pay";
export default {
  name: "order",
  components: { VDistpicker },
  data() {
    return {
      goodsId: "", // 商品id
      goodsSnId: "", // 商品库存id
      goodsNumber: "", // 商品数量
      goodsList: [], // 商品数据
      goodsAddress: [], // 收货地址
      carId: "", // 购物车商品id
      addressId: "", //收货地址id
      addressIds: "", //收货地址选择id
      addressShow: 0, // 是否显示添加地址
      addressShowTab: 0, // 是否显示添加地址
      addressName: "", // 收件人
      addressNameShow: 0,
      addressPhone: "", // 收件人电话
      addressPhones: "",
      addressPhoneShow: 0,
      addressPhoneMessage: "",
      addressDetail: "", // 详情地址
      addressDetailShow: 0,
      defaults: 0, // 默认地址
      addEdit: 0, // 0 添加  1 收藏
      placeholders: {
        province: "请选择",
        city: "请选择",
        area: "请选择"
      },
      select: {
        province: "请选择",
        city: "请选择",
        area: "请选择"
      },
      areaCode: "", // 区级编码
      totalAmount: "", // 总金额
      payAmount: "", // 实付金额
      payType: 0, // 0 支付宝  1 微信
      overlay: 0, // 支付遮罩
      orderSn: "", // 订单编号
      addressShowI: 1, // 无地址提示
      agrees: 1 // 协议
    };
  },
  created() {
    this.goodsId = this.$route.query.goodsId;
    this.goodsSnId = this.$route.query.goodsSnId;
    this.goodsNumber = this.$route.query.goodsNumber;
    this.carId = this.$route.query.carId;
    console.log(this.goodsId);
    console.log(this.goodsSnId);
    console.log(this.goodsNumber);
    console.log(this.carId);
    console.log(localStorage.getItem("idxFrom") == "null");
    if (
      localStorage.getItem("idxTo") == "order" &&
      localStorage.getItem("idxFrom") != "null"
    ) {
      localStorage.removeItem("orderSn");
    } else {
      this.overlay = 1;
    }
    // localStorage.getItem("idxFrom") == "null" ?  this.overlay = 1 : console.log("***************")
    // localStorage.getItem("overpay") ?  : ""
    this.getAddress();
    if (this.carId == undefined) {
      this.goodsPay();
    } else {
      this.carPay();
    }
  },
  methods: {
    onSelected(data) {
      this.areaCode = data.area.code;
    },
    // 添加地址
    addressAdd() {
      this.addEdit = 0;
      this.addressShow = 1;
      this.placeholders.province = "请选择";
      this.placeholders.city = "请选择";
      this.placeholders.area = "请选择";
    },
    // 切换地址
    addressTab() {
      this.addressShowTab = 1;
      this.addressIds = localStorage.getItem("addressId");
    },
    // 取消地址
    addressClose() {
      this.addressShow = 0;
      this.addressShowTab = 0;
      this.addressName = "";
      this.addressPhone = "";
      this.addressDetail = "";
    },
    // 地址选择
    onAddressOrder(id) {
      this.addressIds = id;
    },
    onOrderAdd() {
      this.addressShowTab = 0;
      console.log(this.addressIds);
      localStorage.setItem("addressId", this.addressIds);
      this.getAddress();
    },
    // 收货地址
    async getAddress() {
      console.log(this.addressIds);
      let addressIdStr = localStorage.getItem("addressId");
      console.log(addressIdStr);
      const res = await addrList();
      console.log(res);
      if (res.code == 200) {
        this.goodsAddress = res.data;
        if (res.data.length == 0) {
          this.addressShow = 1;
        }
        if (res.data.length != 0) {
          this.addressShowI = 1;
          this.addressId =
            addressIdStr == null ||
            addressIdStr == "" ||
            addressIdStr == "undefined" ||
            addressIdStr == undefined
              ? res.data[0].id
              : addressIdStr;
        }
      }
    },
    // 是否默认
    onDefault() {
      this.defaults == 1 ? (this.defaults = 0) : (this.defaults = 1);
    },
    // 收件人获取焦点
    addressNameFocus() {
      this.addressNameShow = 0;
    },
    // 手机号获取焦点
    addressPhoneFocus() {
      this.addressPhoneShow = 0;
    },
    // 详情地址获取焦点
    addressDetailFocus() {
      this.addressDetailShow = 0;
    },
    // 添加/修改收货地址
    onSubmitAdd() {
      let _this = this;
      let myreg = /^1[345789]\d{9}$/;
      if (_this.addressName == "") {
        _this.addressNameShow = 1;
      }
      if (_this.addressPhone == "") {
        _this.addressPhoneShow = 1;
        _this.addressPhoneMessage = "手机号码不能为空";
      }
      if (!myreg.test(_this.addressPhone)) {
        if (_this.addressPhones != _this.addressPhone) {
          _this.addressPhoneShow = 1;
          _this.addressPhoneMessage = "请输入正确的手机号码";
        }
      }
      if (_this.addressDetail == "") {
        _this.addressDetailShow = 1;
      }
      console.log(_this.addressPhones);
      if (_this.addressPhones == "") {
        console.log("1");
        if (
          _this.addressName != "" &&
          _this.addressPhone != "" &&
          _this.addressDetail != "" &&
          myreg.test(_this.addressPhone)
        ) {
          addrAdd({
            name: _this.addressName,
            phone: _this.addressPhone,
            postCode: _this.areaCode,
            detailAddress: _this.addressDetail,
            defaultStatus: _this.defaults
          }).then(function(res) {
            console.log(res);
            if (res.code == 200) {
              _this.addressName = "";
              _this.addressNameShow = 0;
              _this.addressPhone = "";
              _this.addressPhoneShow = 0;
              _this.addressDetail = "";
              _this.addressDetailShow = 0;
              _this.getAddress();
              _this.addressShow = 0;
            }
          });
        }
      } else {
        console.log("2");
        console.log(_this.areaCode);
        if (
          _this.addressName != "" &&
          _this.addressPhone != "" &&
          _this.addressDetail != ""
        ) {
          if (
            myreg.test(_this.addressPhone) ||
            _this.addressPhones == _this.addressPhone
          ) {
            let id = _this.addressId;
            let params = {
              name: _this.addressName,
              phone: _this.addressPhone,
              postCode: _this.areaCode,
              detailAddress: _this.addressDetail,
              defaultStatus: _this.defaults
            };
            addrUpdate(id, params).then(function(res) {
              console.log(res);
              if (res.code == 200) {
                _this.addressName = "";
                _this.addressNameShow = 0;
                _this.addressPhone = "";
                _this.addressPhoneShow = 0;
                _this.addressDetail = "";
                _this.addressDetailShow = 0;
                _this.getAddress();
                _this.addressShow = 0;
              }
            });
          }
        }
      }
    },
    // 修改地址
    editAddress(id, name, phone, code, addr, derail, status) {
      console.log(this);
      this.addEdit = 0;
      this.addressShow = 1;
      this.addressId = id;
      this.addressName = name;
      this.addressPhone = phone;
      this.addressPhones = phone;
      this.areaCode = code;
      this.addressDetail = derail;
      this.defaults = status;
      this.select.province = addr.split("-")[0];
      if (addr.split("-")[0] == "北京市") {
        this.select.city = "北京城区";
      } else if (addr.split("-")[0] == "天津市") {
        this.select.city = "天津城区";
      } else if (addr.split("-")[0] == "上海市") {
        this.select.city = "北京城区";
      } else if (addr.split("-")[0] == "香港特别行政区") {
        this.select.city = "香港城区";
      } else if (addr.split("-")[0] == "澳门特别行政区") {
        this.select.city = "澳门城区";
      } else {
        this.select.city = addr.split("-")[1];
      }
      this.select.area = addr.split("-")[2];
    },
    addrSplit(name) {
      return name.replace(/-/g, "");
      // .replace(/市辖区/g, "市辖区")
    },
    // 商品信息-立即购买
    async goodsPay() {
      const res = await orderConfirmBuy({
        productId: this.goodsId,
        productSkuId: this.goodsSnId,
        quantity: this.goodsNumber
      });
      console.log(res);
      if (res.code == 200) {
        this.goodsList = res.data.cartPromotionItemList;
        this.totalAmount = res.data.calcAmount.totalAmount;
        this.payAmount = res.data.calcAmount.payAmount;
      }
    },
    // 商品信息-购物车
    async carPay() {
      const res = await orderConfirmCart({
        ids: this.carId
      });
      console.log(res);
      if (res.code == 200) {
        console.log(data);
        this.goodsList = res.data.cartPromotionItemList;
        this.totalAmount = res.data.calcAmount.totalAmount;
        this.payAmount = res.data.calcAmount.payAmount;
      }
    },
    // 支付方式
    payTab(n) {
      this.payType = n;
    },
    // 协议
    onAgree() {
      this.agrees == 0 ? (this.agrees = 1) : (this.agrees = 0);
    },
    // 付款
    async onPay() {
      let _this = this;
      if (this.agrees == 1) {
        if (this.goodsAddress == 0) {
          this.addressShowI = 0;
        } else {
          let orderSubmitCartParam = {
            memberReceiveAddressId: _this.addressId,
            invoiceEmail: "",
            invoiceHave: 0,
            invoiceNumber: "",
            invoicePhone: "",
            invoiceRise: "",
            invoiceType: 0,
            couponId: 0,
            memberInvoiceId: 0,
            useIntegration: 0,
            message: "",
            payType: _this.payType,
            sourceType: 0,
            ids: _this.carId
          };
          let orderSubmitBuyParam = {
            productId: _this.goodsId,
            productSkuId: _this.goodsSnId,
            quantity: _this.goodsNumber,
            memberReceiveAddressId: _this.addressId,
            invoiceEmail: "",
            invoiceHave: 0,
            invoiceNumber: "",
            invoicePhone: "",
            invoiceRise: "",
            invoiceType: 0,
            couponId: 0,
            memberInvoiceId: 0,
            useIntegration: 0,
            message: "",
            payType: _this.payType,
            sourceType: 0
          };
          _this.overlay = 1;
          console.log(orderSubmitBuyParam);
          localStorage.setItem("overpay", 1);
          if (_this.carId == undefined) {
            const res = await orderSubmitBuy(orderSubmitBuyParam);
            console.log(res);
            if (res.code == 200) {
              _this.orderSn = res.data;
              _this.payCompo(_this.payType, _this.orderSn);
              localStorage.setItem("orderSn", _this.orderSn);
            }
          } else {
            const res = await orderSubmitCart(orderSubmitCartParam);
            console.log(res);
            if (res.code == 200) {
              _this.orderSn = res.data;
              _this.payCompo(_this.payType, _this.orderSn);
              localStorage.setItem("orderSn", _this.orderSn);
            }
          }
        }
      }
    },
    // 已完成付款
    onOrder() {
      localStorage.removeItem("overpay");
      this.$router.push({
        path: "/orderDetail",
        query: {
          id: localStorage.getItem("orderSn"),
          key: 2
        }
      });
    },
    // 支付组件
    async payCompo(payType, orderSn) {
      let _this = this;
      if (payType == 0) {
        // 支付宝支付
        const res = await webAlipay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "payali",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
      } else {
        // 微信支付
        const res = await webWechatPay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "paywx",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
      }
    },
    // 获取购物车数量
    async getCar() {
      let _this = this;
      const res = await cartList();
      console.log(res);
      if (res.code == 200) {
        this.carList = res.data;
        // localStorage.setItem("carNum", res.data.length);
      }
    }
  }
};
</script>

<style scoped>
.order_box {
  margin: 20px auto 0;
  border: solid 1px rgba(218, 218, 218, 1);
  background: #fff;
}
.order_box .top_title {
  color: #999;
  height: 46px;
  padding-left: 24px;
  background: rgba(245, 245, 245, 1);
  border-bottom: solid 1px rgba(218, 218, 218, 1);
}
.order_box .top_title .title {
  float: left;
  line-height: 46px;
}
.order_box .w180 {
  width: 180px;
}
.order_box .w210 {
  width: 210px;
}
.order_box .w400 {
  width: 400px;
}
.order_box .order_address {
  width: 100%;
  padding: 36px 0 18px;
  overflow: hidden;
}
.order_box .order_address .left {
  float: left;
  width: 920px;
  padding-left: 36px;
  position: relative;
}
.order_box .order_address .left::after {
  content: "";
  width: 1px;
  height: 64px;
  overflow: hidden;
  background: #dadada;
  position: absolute;
  top: 40px;
  right: 0;
}
.order_box .order_address .left .line {
  float: left;
  width: 100%;
  padding-bottom: 20px;
}
.order_box .order_address .left .line i {
  float: left;
  width: 26px;
  height: 26px;
  margin-top: 2px;
  background: url("../assets/images/icon_0.png") 0 -225px no-repeat;
}
.order_box .order_address .left .line p {
  float: left;
  color: #333;
  line-height: 30px;
  letter-spacing: 5px;
  padding-left: 10px;
}
.order_box .order_address .left .line span {
  float: left;
  width: 66px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  color: #b4a078;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(180, 160, 120, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-left: 20px;
}
.order_box .order_address .left .p_line {
  float: left;
  width: 100%;
  padding-bottom: 24px;
}
.order_box .order_address .left .p_line p {
  float: left;
  color: #999;
  width: 70px;
}
.order_box .order_address .left .p_line span {
  float: left;
  color: #333;
}
.order_box .order_address .right {
  float: right;
  width: 278px;
  text-align: center;
  padding-top: 40px;
}
.order_box .order_address .right span {
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
}
.order_box .order_address .right span.address_tab {
  color: #69c;
  line-height: 28px;
}
.order_box .order_address .right span.address_adds {
  width: 105px;
  height: 30px;
  line-height: 26px;
  text-align: center;
  color: #333;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  border-radius: 2px;
  margin-top: 10px;
}
/* 添加收货地址 */
.order_box .order_address_add {
  width: 100%;
  padding: 50px 0;
  overflow: hidden;
}
.order_box .order_address_add > .left {
  float: left;
  width: 756px;
  padding: 0 44px;
  border-right: dashed 1px #dadada;
}
.order_box .order_address_add .label {
  width: 100%;
  padding-bottom: 24px;
  overflow: hidden;
  position: relative;
}
.order_box .order_address_add .label .left {
  float: left;
  width: 94px;
  color: #333;
  line-height: 30px;
  text-align: right;
  padding-right: 16px;
}
.order_box .order_address_add .label .left::before {
  content: "*";
  color: #d83c43;
}
.order_box .order_address_add .label .right {
  float: left;
}
.order_box .order_address_add .label .distpicker-address-wrapper >>> select {
  float: left;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  border: solid 1px #dadada;
  padding: 0;
  margin-right: 14px;
  border-radius: 0;
}
.order_box .order_address_add .label textarea {
  float: right;
  width: 573px;
  height: 78px;
  line-height: 36px;
  padding: 0 10px;
  border: solid 1px #dadada;
}
.order_box .order_address_add .label input[type="text"] {
  float: right;
  color: #333;
  width: 220px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  border: solid 1px #dadada;
}
.order_box .order_address_add .label.width {
  width: 314px;
}
.order_box .order_address_add .label.width .left {
  line-height: 38px;
}
.order_box .order_address_add > .right {
  float: right;
  width: 440px;
  padding-left: 65px;
}
.order_box .order_address_add > .right .default {
  float: left;
  width: 100%;
  color: #333;
  line-height: 19px;
  margin-top: 64px;
  margin-bottom: 26px;
}
.order_box .order_address_add > .right .default i {
  float: left;
  width: 19px;
  height: 19px;
  margin-right: 10px;
  cursor: pointer;
  background-image: url("../assets/images/icon_0.png");
  background-position: 0 -122px;
}
.order_box .order_address_add > .right .default.active i {
  background-position: -19px -122px;
}
.order_box .order_address_add > .right .btns {
  float: left;
  font-size: 18px;
  text-align: center;
  line-height: 44px;
  width: 154px;
  height: 46px;
  border-radius: 2px;
  margin-right: 10px;
  cursor: pointer;
}
.order_box .order_address_add > .right .btns.btns_submit {
  color: #fff;
  background: rgba(180, 160, 120, 1);
  border: 1px solid rgba(180, 160, 120, 1);
}
.order_box .order_address_add > .right .btns.btns_close {
  color: #333;
  background: rgba(245, 243, 239, 1);
  border: 1px solid rgba(180, 160, 120, 1);
}
.order_box .order_address_add .label .errmes {
  color: #d4282d;
  font-size: 12px;
  line-height: 13px;
  overflow: hidden;
  position: absolute;
  left: 94px;
  bottom: 6px;
}
.order_box .order_address_add .label .errmes i {
  float: left;
  width: 13px;
  height: 13px;
  margin-right: 5px;
  background-image: url("../assets/images/icon_0.png");
  background-repeat: no-repeat;
  background-position: -66px -122px;
}
/* 商品信息 */
.order_box .goods_list {
  width: 100%;
  overflow: hidden;
}
.order_box .goods_list li {
  float: left;
  width: 1150px;
  padding: 20px 0;
  margin-left: 24px;
  border-top: dashed 1px #dadada;
}
.order_box .goods_list li:first-child {
  border-top-width: 0;
}
.order_box .goods_list li .infor img {
  float: left;
  width: 110px;
  height: 110px;
  margin-right: 12px;
}
.order_box .goods_list li .infor p {
  display: block;
  color: #333;
  line-height: 24px;
  padding-top: 5px;
}
.order_box .goods_list li .infor span {
  display: block;
  color: #999;
  line-height: 24px;
}
.order_box .goods_list li .title {
  font-size: 0;
}
.order_box .goods_list li .title span,
.order_box .goods_list li .title del {
  color: #333;
  display: inline-block;
  vertical-align: top;
}
.order_box .goods_list li .title del {
  color: #999;
  padding-left: 7px;
}
/* 支付方式 */
.order_box .pay_aw {
  width: 100%;
  padding: 50px 40px;
  overflow: hidden;
}
.order_box .pay_aw label {
  float: left;
  height: 47px;
  margin-right: 50px;
  cursor: pointer;
}
.order_box .pay_aw label i {
  float: left;
}
.order_box .pay_aw label i.pay_radio {
  height: 15px;
  width: 15px;
  background-image: url("../assets/images/icon_2.png");
  background-repeat: no-repeat;
  background-position: 0 -212px;
  margin: 16px 10px 0 0;
}
.order_box .pay_aw label i.pay_radio.active {
  background-position: 0 -187px;
}
.order_box .pay_aw label i.payali,
.order_box .pay_aw label i.paywx {
  background-image: url("../assets/images/icon_3.png");
  background-repeat: no-repeat;
}
.order_box .pay_aw label i.payali {
  width: 133px;
  height: 47px;
  background-position: 0 0;
}
.order_box .pay_aw label i.paywx {
  width: 134px;
  height: 39px;
  background-position: 0 -478px;
  margin-top: 4px;
}
/* 结算信息 */
.goods_order {
  padding: 30px 54px;
  border: solid 1px #dadada;
  border-top-width: 0;
  background: #f5f5f5;
}
.goods_order .right {
  float: right;
  width: 310px;
  text-align: right;
}
.goods_order .amount {
  float: left;
  width: 100%;
  padding-bottom: 24px;
}
.goods_order .amount dt,
.goods_order .amount dd {
  color: #333;
  display: inline-block;
  vertical-align: top;
}
.goods_order .amount dd {
  width: 180px;
}
.goods_order hr {
  float: right;
  width: 308px;
  height: 1px;
  overflow: hidden;
  background: #dadada;
  margin: 6px 0 25px;
}
.goods_order .pay {
  float: left;
  width: 100%;
  padding-bottom: 28px;
}
.goods_order .pay dt,
.goods_order .pay dd {
  color: #333;
  display: inline-block;
  vertical-align: bottom;
}
.goods_order .pay dd {
  color: #d4282c;
  font-size: 22px;
  font-weight: bold;
  width: 130px;
}
.goods_order .btn_pay {
  float: right;
  width: 185px;
  height: 54px;
  line-height: 54px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin-bottom: 30px;
  background: rgba(180, 160, 120, 1);
}
.goods_order .btn_pay.active {
  background: #cdcbcb;
}
.goods_order .goods_order_btn {
  float: right;
  width: 185px;
  height: 74px;
  position: relative;
}
.goods_order .goods_order_btn .errmepay {
  color: #d4282d;
  font-size: 12px;
  line-height: 13px;
  overflow: hidden;
  position: absolute;
  right: 0;
  bottom: 0;
}
.goods_order .goods_order_btn .errmepay i {
  float: left;
  width: 13px;
  height: 13px;
  margin-right: 5px;
  background-image: url("../assets/images/icon_0.png");
  background-repeat: no-repeat;
  background-position: -66px -122px;
}
.goods_order .adderss_bottom {
  float: left;
  width: 100%;
  color: #333;
}
.goods_order .adderss_bottom span {
  float: right;
  padding-left: 13px;
  padding-bottom: 10px;
}
.goods_order .adderss_bottom p {
  float: right;
  width: 100%;
}
.agree {
  padding: 15px 0 60px;
}
.agree .image {
  float: right;
  color: #999;
  line-height: 19px;
}
.agree .image i {
  float: left;
  width: 19px;
  height: 19px;
  margin-right: 10px;
  cursor: pointer;
  background-image: url("../assets/images/icon_0.png");
  background-position: 0 -122px;
}
.agree .image.active i {
  background-position: -19px -122px;
}
.agree a {
  float: right;
  color: #69c;
  line-height: 19px;
}
/* 切换收货地址 */
.yu_mask .address_tabs {
  width: 690px;
  height: 674px;
  margin: 0 auto;
  padding: 44px 56px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin-top: -337px;
  z-index: 245;
}
.yu_mask .address_tabs .title {
  color: #333;
  font-size: 20px;
  padding-bottom: 47px;
}
.yu_mask .address_tabs .over_auto {
  width: 578px;
  height: 375px;
  overflow: hidden;
}
.yu_mask .address_tabs .list {
  width: 600px;
  height: 375px;
  overflow-x: hidden;
  overflow-y: auto;
}
.yu_mask .address_tabs .list li {
  float: left;
  width: 578px;
  padding: 24px 0 16px 30px;
  margin-bottom: 10px;
  border: 1px solid rgba(218, 218, 218, 1);
}
.yu_mask .address_tabs .list li.active {
  border: 1px solid rgba(180, 160, 120, 1);
  position: relative;
}
.yu_mask .address_tabs .list li.active::before {
  content: "";
  width: 19px;
  height: 19px;
  background: url("../assets/images/icon_0.png") 0 -183px no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 3;
}
.yu_mask .address_tabs .list li .p_label {
  float: left;
  width: 445px;
}
.yu_mask .address_tabs .list li .p_label p {
  float: left;
  color: #999;
  width: 70px;
  line-height: 30px;
}
.yu_mask .address_tabs .list li .p_label span {
  float: left;
  color: #333;
  width: 365px;
  line-height: 30px;
}
.yu_mask .address_tabs .btn_addr {
  font-size: 0;
  text-align: center;
  margin-top: 98px;
}
.yu_mask .address_tabs .btns {
  font-size: 18px;
  line-height: 44px;
  width: 154px;
  height: 46px;
  border-radius: 2px;
  margin: 0 3px;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
}
.yu_mask .address_tabs .btns.btns_submit {
  color: #fff;
  background: rgba(180, 160, 120, 1);
  border: 1px solid rgba(180, 160, 120, 1);
}
.yu_mask .address_tabs .btns.btns_close {
  color: #333;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(218, 218, 218, 1);
}
/* 支付遮罩 */
.yu_mask .over_lay {
  width: 730px;
  height: 420px;
  text-align: center;
  padding-top: 90px;
  margin: 0 auto;
  background: rgba(251, 251, 251, 1);
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin-top: -210px;
  z-index: 245;
}
.yu_mask .over_lay .text_h3 {
  color: #333;
  font-size: 20px;
}
.yu_mask .over_lay .text_h3 span {
  color: #d4282d;
}
.yu_mask .over_lay .text_clear {
  font-size: 0;
  text-align: center;
  padding: 72px 0 60px;
}
.yu_mask .over_lay .text_clear .left,
.yu_mask .over_lay .text_clear .right {
  width: 220px;
  padding: 0 30px;
  display: inline-block;
  vertical-align: top;
}
.yu_mask .over_lay .text_clear .left {
  border-right: solid 1px #dadada;
}
.yu_mask .over_lay .text_clear .left p,
.yu_mask .over_lay .text_clear .right p {
  color: #333;
  padding-bottom: 10px;
}
.yu_mask .over_lay .text_clear .left a,
.yu_mask .over_lay .text_clear .right a {
  display: block;
  width: 160px;
  height: 46px;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
  border-radius: 2px;
}
.yu_mask .over_lay .text_clear .left a {
  color: #333;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(218, 218, 218, 1);
}
.yu_mask .over_lay .text_clear .right a {
  color: #fefefe;
  background: rgba(180, 160, 120, 1);
  border: 1px solid rgba(218, 218, 218, 1);
}
.yu_mask .over_lay .text_p {
  color: #333;
}
</style>